import { createFileRoute, redirect } from '@tanstack/react-router';

import { getDefaultPeriod } from '@/features/contract-and-cost/period';

export const Route = createFileRoute(
  '/_staff/software/_layout/contract-and-cost/_contract-and-cost/cost/',
)({
  beforeLoad: () => {
    throw redirect({
      to: '/software/contract-and-cost/cost/$period',
      params: { period: getDefaultPeriod() },
    });
  },
});
